export default function header() {
  let user = null;

  // Sesi bisa saja sudah dibersihkan atau isinya rusak; jangan sampai pembacaannya
  // melempar error dan menggagalkan request yang justru dipakai untuk logout.
  try {
    user = JSON.parse(localStorage.getItem('user'));
  } catch (e) {
    user = null;
  }

  if (user && user.token) {
    return {
      Authorization: 'Bearer ' + user.token
    };
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/api/auth/header.js